module.exports = __webpack_public_path__ + "static/media/dcl.5c6daab8.png";